import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  CardTitle,
  CardSubtitle,
} from "reactstrap";
import ButtonSpinner from "../../../../components/Buttons/ButtonSpinner";

export default function ConfigurationsList({
  configListForm,
  setConfigListForm,
  trySaveConfigs,
  attributesList,
  attributesListLabel,
  schedulesList,
}) {
  if (!configListForm) {
    return null;
  }
  return (
    <div style={{ paddingBottom: '10px' }}>
      {renderUrlKioskModeField()}
      {renderGuestsFields()}
      {renderLabelFields()}
      {renderRegisterFormFields()}
      {renderConfirmationFormFields()}
      {renderColorStyleFormFields()}
      {renderColorStyleExample()}

      <Row
        style={{
          width: "100%",
          margin: "auto",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <ButtonSpinner
          // isLoading={isLoading} 
          title={"Salvar"}
          onClick={() => trySaveConfigs()}
        />
      </Row>
    </div>
  )

  function renderUrlKioskModeField() {
    return (
      <>
        <CardTitle>Configurações</CardTitle>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`URL imagem modo quiosque vertical = 1600 x 2560 pixels`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.urlKioskMode}
              onChange={(e) => setConfigListForm({ ...configListForm, urlKioskMode: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`URL imagem modo quiosque horizontal = 2560 x 1600 pixels`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.urlKioskModeLandscape}
              onChange={(e) => setConfigListForm({ ...configListForm, urlKioskModeLandscape: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`URL tela confirmação vertical`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.urlKioskMode2}
              onChange={(e) => setConfigListForm({ ...configListForm, urlKioskMode2: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`URL tela confirmação horizontal`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.urlKioskModeLandscape2}
              onChange={(e) => setConfigListForm({ ...configListForm, urlKioskModeLandscape2: e.target.value })}
            />
          </Col>
        </Row>
      </>
    )
  }

  function renderGuestsFields() {
    return (
      <>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Mostrar participantes`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.confirmedGuests}
              onChange={(e) => setConfigListForm({ ...configListForm, confirmedGuests: e.target.value })}
            >
              <option value="false">Todos</option>
              <option value="true">Apenas Confirmados</option>
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Texto do campo Buscar Participante`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.serchGuestsText}
              onChange={(e) => setConfigListForm({ ...configListForm, serchGuestsText: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`URL ou HTML Termos de Aceite`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.signatureTerms}
              onChange={(e) => setConfigListForm({ ...configListForm, signatureTerms: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Identificador do Participante`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.guestIdentifier}
              onChange={(e) => setConfigListForm({ ...configListForm, guestIdentifier: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Bloquear QR Code após check-in na programação`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.blockQrCode}
              onChange={(e) => setConfigListForm({ ...configListForm, blockQrCode: e.target.value })}
            >
              <option value="">Selecione</option>
              {schedulesList && schedulesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Atribuir ID sequencial`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.scheduleSerialNumber}
              onChange={(e) => setConfigListForm({ ...configListForm, scheduleSerialNumber: e.target.value })}
            >
              <option value="">Selecione</option>
              {schedulesList && schedulesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
      </>
    )
  }

  function renderLabelFields() {
    return (
      <>
        <CardTitle>Etiqueta</CardTitle>
        <CardSubtitle>Para os modelos de 1 a 5 o atributo Nome estará inclusos por padrão</CardSubtitle>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Modelo de Etiqueta`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.labelModel}
              onChange={(e) => setConfigListForm({ ...configListForm, labelModel: e.target.value })}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo de Etiqueta 1`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.labelField1}
              onChange={(e) => setConfigListForm({ ...configListForm, labelField1: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesListLabel && attributesListLabel.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        {parseInt(configListForm.labelModel) > 1 && (
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <Label htmlFor="formFile" className="form-label">
                {`Campo de Etiqueta 2`}
              </Label>
              <Input
                className="form-control"
                type="select"
                value={configListForm.labelField2}
                onChange={(e) => setConfigListForm({ ...configListForm, labelField2: e.target.value })}
              >
                <option value="">Selecione</option>
                {attributesListLabel && attributesListLabel.map((a, i) => {
                  return (<option key={i} value={a.value}>{a.text}</option>)
                })}
              </Input>
            </Col>
          </Row>
        )}
        {parseInt(configListForm.labelModel) > 2 && (
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <Label htmlFor="formFile" className="form-label">
                {`Campo de Etiqueta 3`}
              </Label>
              <Input
                className="form-control"
                type="select"
                value={configListForm.labelField3}
                onChange={(e) => setConfigListForm({ ...configListForm, labelField3: e.target.value })}
              >
                <option value="">Selecione</option>
                {attributesListLabel && attributesListLabel.map((a, i) => {
                  return (<option key={i} value={a.value}>{a.text}</option>)
                })}
              </Input>
            </Col>
          </Row>
        )}
        {parseInt(configListForm.labelModel) > 3 && (
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <Label htmlFor="formFile" className="form-label">
                {`Campo de Etiqueta 4`}
              </Label>
              <Input
                className="form-control"
                type="select"
                value={configListForm.labelField4}
                onChange={(e) => setConfigListForm({ ...configListForm, labelField4: e.target.value })}
              >
                <option value="">Selecione</option>
                {attributesListLabel && attributesListLabel.map((a, i) => {
                  return (<option key={i} value={a.value}>{a.text}</option>)
                })}
              </Input>
            </Col>
          </Row>
        )}
        {parseInt(configListForm.labelModel) > 4 && (
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <Label htmlFor="formFile" className="form-label">
                {`Campo de Etiqueta 5`}
              </Label>
              <Input
                className="form-control"
                type="select"
                value={configListForm.labelField5}
                onChange={(e) => setConfigListForm({ ...configListForm, labelField5: e.target.value })}
              >
                <option value="">Selecione</option>
                {attributesListLabel && attributesListLabel.map((a, i) => {
                  return (<option key={i} value={a.value}>{a.text}</option>)
                })}
              </Input>
            </Col>
          </Row>
        )}
        {parseInt(configListForm.labelModel) === 6 && (
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <Label htmlFor="formFile" className="form-label">
                {`Texto ZPL para etiqueta modelo 6`}
              </Label>
              <Input
                className="form-control"
                type="text"
                value={configListForm.customZebraLabelText}
                onChange={(e) => setConfigListForm({ ...configListForm, customZebraLabelText: e.target.value })}
              />
            </Col>
          </Row>
        )}
      </>
    )
  }

  function renderRegisterFormFields() {
    return (
      <>
        <CardTitle>Cadastro</CardTitle>
        <CardSubtitle>O formulário de cadastro terá o atributo Nome incluso por padrão</CardSubtitle>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 1`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField1}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField1: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 2`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField2}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField2: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 3`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField3}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField3: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 4`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField4}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField4: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 5`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField5}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField5: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 6`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField6}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField6: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 7`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField7}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField7: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 8`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField8}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField8: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 9`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField9}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField9: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 10`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField10}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField10: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 11`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField11}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField11: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 12`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField12}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField12: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 13`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField13}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField13: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 14`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField14}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField14: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 15`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField15}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField15: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 16`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField16}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField16: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 17`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField17}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField17: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 18`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField18}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField18: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 19`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField19}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField19: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo Cadastro 20`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.registerField20}
              onChange={(e) => setConfigListForm({ ...configListForm, registerField20: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
      </>
    )
  }

  function renderConfirmationFormFields() {
    return (
      <>
        <CardTitle>Tela de Confirmação</CardTitle>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo 1`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.confirmationField1}
              onChange={(e) => setConfigListForm({ ...configListForm, confirmationField1: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo 2`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.confirmationField2}
              onChange={(e) => setConfigListForm({ ...configListForm, confirmationField2: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo 3`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.confirmationField3}
              onChange={(e) => setConfigListForm({ ...configListForm, confirmationField3: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo 4`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.confirmationField4}
              onChange={(e) => setConfigListForm({ ...configListForm, confirmationField4: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Campo 5`}
            </Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.confirmationField5}
              onChange={(e) => setConfigListForm({ ...configListForm, confirmationField5: e.target.value })}
            >
              <option value="">Selecione</option>
              {attributesList && attributesList.map((a, i) => {
                return (<option key={i} value={a.value}>{a.text}</option>)
              })}
            </Input>
          </Col>
        </Row>
      </>
    )
  }

  function renderColorStyleFormFields() {
    return (
      <>
        <CardTitle>Cores</CardTitle>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Cor Background`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.colorBackground}
              onChange={(e) => setConfigListForm({ ...configListForm, colorBackground: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Cor Texto`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.colorText}
              onChange={(e) => setConfigListForm({ ...configListForm, colorText: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Cor Botão`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.colorButton}
              onChange={(e) => setConfigListForm({ ...configListForm, colorButton: e.target.value })}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label htmlFor="formFile" className="form-label">
              {`Cor Texto Botão`}
            </Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.colorTextButton}
              onChange={(e) => setConfigListForm({ ...configListForm, colorTextButton: e.target.value })}
            />
          </Col>
        </Row>
      </>
    )
  }

  function renderColorStyleExample() {
    return (
      <div style={{ paddingBottom: 10 }}>
        <CardSubtitle>Exemplo</CardSubtitle>
        <div
          style={{
            backgroundColor: configListForm.colorBackground,
            width: '100%',
            padding: '5px',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div
            style={{
              backgroundColor: configListForm.colorBackground || 'white',
              width: '100%',
              padding: '10px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                backgroundColor: configListForm.colorBackground,
                width: '100%',
                padding: 5,
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div
                style={{
                  fontSize: 17,
                  color: configListForm.colorText || 'white',
                  fontFamily: 'verdana',
                }}
              >
                EXEMPLO DE TEXTO
              </div>
            </div>
            <div
              style={{
                alignItems: "center",
                backgroundColor: configListForm.colorButton,
                padding: '8px',
                borderRadius: '5px',
                color: configListForm.colorTextButton,
                fontFamily: 'verdana',
                fontSize: 16,
                textAlign: 'center',
              }}
            >
              EXEMPLO BOTÃO
            </div>
          </div>
        </div>
      </div>
    )
  }
}
